import type { LanguageServerComponentImplementation } from '../types'
import * as FPlusLanguageServer from './FPlusLanguageService'

export const getFPlusLanguageServer =
  (): LanguageServerComponentImplementation => FPlusLanguageServer
